export var TabColors = {
  container: {
    default: {
      light: {
        background: 'transparent',
        textColor: 'var(--text-color-dim)',
        underline: 'var(--white)'
      },
      dark: {
        background: 'transparent',
        textColor: 'var(--text-color-dim)',
        underline: 'var(--purple-8)'
      }
    },
    hover: {
      light: {
        background: 'var(--gray-3)',
        textColor: 'var(--text-color)',
        underline: 'var(--gray-5)'
      },
      dark: {
        background: 'var(--purple-6)',
        textColor: 'var(--text-color)',
        underline: 'var(--purple-2)'
      }
    },
    focus: {
      light: {
        background: 'var(--purple-2)',
        textColor: 'var(--text-color)',
        underline: 'var(--gray-5)'
      },
      dark: {
        background: 'var(--purple-7)',
        textColor: 'var(--text-color)',
        underline: 'var(--purple-2)'
      }
    },
    selected: {
      light: {
        background: 'var(--gray-2)',
        textColor: 'var(--text-color)',
        underline: 'var(--pink-core)'
      },
      dark: {
        background: 'var(--purple-7)',
        textColor: 'var(--text-color)',
        underline: 'var(--pink-core)'
      }
    }
  },
  'page-level': {
    default: {
      light: {
        background: 'transparent',
        textColor: 'var(--text-color-dim)',
        underline: 'var(--gray-3)'
      },
      dark: {
        background: 'transparent',
        textColor: 'var(--text-color-dim)',
        underline: 'var(--purple-2)'
      }
    },
    hover: {
      light: {
        background: 'var(--gray-3)',
        textColor: 'var(--text-color)',
        underline: 'var(--gray-5)'
      },
      dark: {
        background: 'var(--purple-7)',
        textColor: 'var(--text-color)',
        underline: 'var(--purple-6)'
      }
    },
    focus: {
      light: {
        background: 'var(--purple-2)',
        textColor: 'var(--text-color)',
        underline: 'var(--gray-5)'
      },
      dark: {
        background: 'var(--purple-8)',
        textColor: 'var(--text-color)',
        underline: 'var(--purple-6)'
      }
    },
    selected: {
      light: {
        background: 'transparent',
        textColor: 'var(--text-color)',
        underline: 'var(--pink-core)'
      },
      dark: {
        background: 'transparent',
        textColor: 'var(--text-color)',
        underline: 'var(--pink-core)'
      }
    }
  }
};